import { useSelector, useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { setSelectedRegionData, setSelectedSitesData, setSelectedCircleData, setSelectedCityData } from "../components/GlobalContext/GlobalfiltersData";
import { useLocation } from 'react-router-dom';
export function useGlobalFilterData() {
  // Existing selectors
  const selectedFields = useSelector((state) => state.globalFilterReducer.get('filters'));
  const availableFields = useSelector((state) =>
    state.globalFilterReducer.get('availableFields')
  );
  const test = useSelector((state) =>
    state.dateTimeReducer.monitoringStart
  );
  const location=useLocation()
console.log('loccheckuseGlobal',location.pathname === '/view/infra-topology'?'top':location.pathname === '/monitoring'?test:'not');

  const startDate = useSelector((state) => location.pathname === '/view/infra-topology'?state.dateTimeReducer.topologyStart:location.pathname === '/monitoring'?state.dateTimeReducer.monitoringStart:state.dateTimeReducer.start);
  const endDate = useSelector((state) => location.pathname === '/view/infra-topology'?state.dateTimeReducer.topologyend:location.pathname === '/monitoring'?state.dateTimeReducer.monitoringend:state.dateTimeReducer.end);
  const filters = useSelector((state) => state.globalFilterReducer.get('filters'));
  const selectedRegions = useSelector((state) => state.regionReducer.selectedRegions);
  const selectedCircles = useSelector((state) => state.regionReducer.selectedCircles);  // New
  const selectedCities = useSelector((state) => state.regionReducer.selectedCities);    // New
  const selectedSites = useSelector((state) => state.regionReducer.selectedSites);
  const regionData = useSelector((state) => state.regionReducer.regionData);
  const circleData = useSelector((state) => state.regionReducer.circleData);
  const searchString = useSelector((state) => state.searchTextReducer.searchText);
  const selectedVendor = useSelector((state) => state.regionReducer.selectedVendor);
  const selectedTechnology = useSelector((state) => state.regionReducer.selectedTechnology);
  const selectedTemporal = useSelector((state) => state.regionReducer.selectedTemporal);
  const selectedRegional = useSelector((state) => state.regionReducer.selectedRegional);


  const dispatch = useDispatch();

  return useMemo(() => {    
    return {
      selectedFields,
      availableFields,
      startDate,
      endDate,
      filters,
      selectedRegions,
      selectedCircles,
      selectedCities,
      selectedSites,
      searchString,
      selectedVendor,
      selectedTechnology,
      selectedRegional,
      selectedTemporal,
      regionData,
      circleData,
      dispatch
    };
  }, [
    selectedFields,
    availableFields,
    startDate,
    endDate,
    filters,
    selectedRegions,
    selectedCircles,
    selectedCities,
    selectedSites,
    searchString,
    selectedVendor,
    selectedTechnology,
    selectedRegional,
    selectedTemporal,
    regionData,
    circleData,
    dispatch
  ]);
}
